/* eslint-disable */
import React, {Component, useState} from 'react';
import {Container, Atencao, DivAccordion, StyledTbody, DivAccordionMobile} from './styles';
import { Link, Redirect } from 'react-router-dom';
import Carrinho from '../../assets/emojis/carrinho/carrinho@3x.png';
import Alerta from '../../assets/icones/icon_alert-triangle.svg';
import {FiChevronDown} from 'react-icons/fi';
import {Switch} from 'antd';
import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';
import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io';
import Modal from 'react-modal';
import ModalProduto from './modalProduto';
import ModalApagar from './modalApagar';
import CategModal from './modalCategoria';
import api from '../../services/api';
import {FiGrid, FiList, FiTrash2} from 'react-icons/fi';
import {MdReorder, MdMoreVert} from 'react-icons/md';
import Collapse from "@kunukn/react-collapse";
import {Menu, MenuItem, Fade} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { RenderCateg } from '../../components/Products';

export default class Produtos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            token: null,
            rest: {}, 
            superUser: false,
            permission: null,
            redirect: null,
            alerta: true,
            saved: true,
            filtroOpen: false,
            modalProduto: false,
            windowWidth: window.innerWidth,
            categorias: [],
            edicao: false,
            produto_id: null,
            loaded: false,
            modalCategoria: false,
            list: true,
            categoria: '',
            categoria_id: null,
            modalApagar: false,
            isCateg: false,
            nome_delete: '',
            id_delete: null
        };
    } 

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    async componentDidMount() {
        toast.configure();
        Modal.setAppElement('body');
        const token = await localStorage.getItem('@jwt');
        const isSuser = await localStorage.getItem('@internal');
        const rest = await JSON.parse(localStorage.getItem('@rest'));
        this.setState({ token: token, rest });
        if(isSuser) {
            const permissions = await JSON.parse(localStorage.getItem('@suser'));
            this.setState({superUser: true, permission: permissions.configuracoes})
        }
        if(this.state.superUser) {
            if(this.state.permission !== 0) {
                await this.getProdutos().then(() => {
                    this.setState({carregou: true});
                })
            }
        } else {
            const produtos = await this.getProdutos()
            .then(() => {
                this.setState({carregou: true});
            })
        }
        if (this.state.carregou) {
            window.addEventListener("resize", this.handleResize);
        }
    }

    async componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize, false)
    }

    async getProdutos() {
        try {
            console.log('cheguei no get')
            await api.get('api/produtos/listar', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res)
                this.setState({
                    categorias: res.data,
                    loaded: true,
                });
                console.log(res.data)
            }).catch(async e => {
                console.log({e: e})
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (e) {
            console.log(e);
        }
    }

    success = () => {
        toast.dismiss();
        const ToastSuccess = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCheckmarkCircle color="#51db74" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#5b8e3e",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>As alterações foram salvas com sucesso.</span>
                </div>
            </div>
        );
        toast.success(<ToastSuccess />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide,
        });
    }
    error = () => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>Ocorreu um erro. Tente novamente mais tarde.</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    customError = (text) => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>{text}</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    filtroModal(estado){
        this.setState({
            filtroOpen: !estado
        });
      }

      controllerModalProduto(estado, edicao, produto_id, categoria, categoria_id){
        const {modalProduto} = this.state;
        if (!modalProduto) {
            this.setState({
                modalProduto: !estado,
                edicao,
                produto_id,
                categoria,
                categoria_id
            });
        } else {
            this.setState({
                modalProduto: !estado,
            });
            setTimeout(() => {
                this.setState({
                    edicao,
                    produto_id,
                    categoria,
                    categoria_id
                })
            }, 100)
        }
      }

      async handleAtivo(categ_id, id, ativo) {
        let array = this.state.categorias;
        try {
            await api.put('api/produtos/atualizar', {
                produto_id: id,
                ativo
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res.data);
                for (let i = 0; i < array.length; i++) {
                    if (array[i].id === categ_id) {
                        for (let j = 0; j < array[i].produtos.length; j++) {
                            if (array[i].produtos[j].id === id) {
                                array[i].produtos[j].ativo = ativo
                            }
                        }
                    }
                }
                this.setState({ 
                    categorias: array
                });
                this.success();
            })
        } catch (e) {
            console.log(e);
            this.error();
        }
    }

    async handleAtivoCateg(id, ativo) {
        let array = this.state.categorias;
        try {
            await api.put('api/categorias/atualizar', {
                id,
                ativo
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res.data);
                for (let i = 0; i < array.length; i++) {
                    if (array[i].id === id) {
                        array[i].ativo = ativo
                    }
                }
                this.setState({ 
                    categorias: array
                });
                this.success();
            })
        } catch (e) {
            console.log(e);
            this.error();
        }
    }

    controllerModalCateg(state) {
        this.setState({
            modalCategoria: !state
        });
    }

    async createCateg(nome) {
        try {
            await api.post('api/categorias/criar', {
                nome
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res.data);
                this.getProdutos();
                this.controllerModalCateg(this.state.modalCategoria);
                this.success();
            })
        } catch (error) {
            console.log(error);
            this.error();
        }
    }

    async delCateg(id) {
        try {
            await api.put('api/categorias/deletar', {
                id
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.getProdutos();
                this.success();
            })
        } catch (e) {
            console.log(e);
            this.error();
        }
    }

    async delProd(id) {
        try {
            await api.delete(`api/produtos/deletar/${id}`, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.getProdutos();
                this.success();
            })
        } catch (e) {
            console.log(e);
            this.error();
        }
    }

    controllerModalApagar(state, isCateg, nome, id) {
        this.setState({
            modalApagar: !state,
            isCateg,
            nome_delete: nome,
            id_delete: id
        })
    }

    async handleDelete(id) {
        if (this.state.isCateg) {
            await this.delCateg(id);
        } else {
            await this.delProd(id);
        }
        this.controllerModalApagar(this.state.modalApagar, false, '', null);
    }

    orderCateg(items) {
        const ordered = items.map((item, index) => {
            item.ordem = index + 1;
            // item.produtos = [];
            return {...item}
        });
        console.log(ordered);
        try {
            api.patch('api/categorias/ordenar', {
                categorias: ordered
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res.data);
                this.success();
            }).catch(e => {
                this.error();
            })
        } catch (e) {
            console.log(e.data);
        }
    }

    handleOnDragEndCateg = (result) => {
        if (!result.destination) return;
        const items = Array.from(this.state.categorias);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        this.orderCateg(items);
    }

    orderProd(items, categ_id) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].id === categ_id) {
                var ordered = items[i].produtos.map((item, index) => {
                    item.ordem = index + 1;
                    return {...item}
                });
            }
        }
        try {
            api.patch('api/produtos/ordenar', {
                produtos: ordered
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res.data);
                this.success();
            }).catch(e => {
                this.error();
            })
        } catch (e) {
            console.log(e.data);
        }
    }

    handleOnDragEndProd = (result, id) => {
        if (!result.destination) return;
        const items = Array.from(this.state.categorias);
        for (let i = 0; i < items.length; i++) {
            if (items[i].id === id) {
                const [reorderedItem] = items[i].produtos.splice(result.source.index, 1);
                items[i].produtos.splice(result.destination.index, 0, reorderedItem);

            }
        };
        this.orderProd(items, id);
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/login"/>
        }        
    return(
        this.state.superUser && this.state.permission === 0 ? (
            <Container>
                    <h1 style={{
                        fontFamily: 'Montserrat',
                        fontSize: 18,
                        fontWeight: 600
                    }}>Você não possui permissão para visualizar esta página.</h1>
                </Container>
        ) : (
        <Container>
            <ToastContainer limit={1} />
            <Modal
                isOpen={this.state.modalApagar}
                // onAfterOpen={this.controllerModal(this.state.isOpen)}
                onRequestClose={() => this.controllerModalApagar(this.state.modalApagar, false, '', null)}
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                closeTimeoutMS={100}
                style={apagarStyle}
                contentLabel="Modal"
                >
                    <ModalApagar 
                        isCateg={this.state.isCateg}
                        nome={this.state.nome_delete}
                        id={this.state.id_delete}
                        confirm={(id) => this.handleDelete(id)}
                        closeModal={() => this.controllerModalApagar(this.state.modalApagar, false, '', null)}
                    />
                </Modal>
            <Modal
                isOpen={this.state.modalProduto}
                // onAfterOpen={this.controllerModal(this.state.isOpen)}
                onRequestClose={() => this.controllerModalProduto(this.state.modalProduto, false, null, '', null)}
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                closeTimeoutMS={100}
                style={this.state.windowWidth > 600 ? customStyles : customStylesMobile}
                contentLabel="Modal"
                >
                    <ModalProduto
                        // salvar={(id, turno, entrada, saida) => this.salvar(id, turno, entrada, saida)}
                        // id={this.state.id}
                        // turno={this.state.qualTurno}
                        success={() => this.success()}
                        error={() => this.error()}
                        customError={(text) => this.customError(text)}
                        produto={this.state.produto_id}
                        categoria={this.state.categoria}
                        categoria_id={this.state.categoria_id}
                        edicao={this.state.edicao}
                        categorias={this.state.categorias}
                        refresh={() => this.getProdutos()}
                        token={this.state.token}
                        closeModal={() => this.controllerModalProduto(this.state.modalProduto, false, null, '', null)}/>
            </Modal>
                <Modal
                    isOpen={this.state.modalCategoria}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalCateg(this.state.modalCategoria)}
                    closeModal={() => this.controllerModalCateg(this.state.modalCategoria)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 784 ? customStylesCateg : filtroStylesMob}
                    contentLabel="Modal"
                    >
                        <CategModal
                            criar={(nome) => this.createCateg(nome)}
                            closeModal={() => this.controllerModalCateg(this.state.modalCategoria)}/>
                </Modal>
            {this.state.loaded ?
        <>
        <div className="div-pai">
            <div className="div-rota">

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/'}>
                <span
                    className="rotas" >
                    Início
                </span>
            </Link>

            <span className="rotas"> {'>'} </span>

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/produtos'}>
                <span>
                    Produtos
                </span>
            </Link>

            </div>

            <div className="titulo">

                <img alt="" className="emoji" src={Carrinho} />

                <h1>Produtos</h1>

                <h5>Adicione e configure categorias e produtos para o seu restaurante.</h5>

            </div>   

            <Atencao open={this.state.alerta}>
                <div className="box" 
                    // onClick={() => this.setState({alerta: !this.state.alerta})}
                >
                    <div className="left">
                        <img alt="" src={Alerta} className="alerta"/>
                        <h5>Atenção</h5>
                    </div>
                    {/* <FiChevronDown color={'#000000'} size={24} className="chevron"/> */}
                </div>

                {/* { this.state.alerta ?  */}
                <div className="textos">
                    <h5>É expressamente proibida a divulgação de números <p>de telefone dentro do aplicativo.</p></h5>
                </div>
                <div className="textos-mobile">
                    <h5>É expressamente proibida a divulgação de números de telefone dentro do aplicativo.</h5>
                </div>
                {/* : null} */}
            </Atencao>

            <hr className="linha"/>

            <div className="categorias-e-produtos">
                    <h2>Categorias e produtos</h2>
                    {!!this.state.categorias.length ? (
                        <>
                        <div className="modos">
                            <div className="card"
                                onClick={() => this.setState({
                                    list: false
                                })}>
                                <FiGrid 
                                    color={this.state.list ? '#a49b9b' : '#000000'}
                                    size={16}/>
                                <h3 style={this.state.list ? {color: "#a49b9b"} : {color: "#000000"}}>Card</h3>
                            </div>
                            <div className="lista"
                                onClick={() => this.setState({
                                    list: true
                                })}>
                                <FiList 
                                    color={!this.state.list  ? '#a49b9b' : '#000000'}
                                    size={16}/>
                                <h3 style={!this.state.list  ? {color: "#a49b9b"} : {color: "#000000"}}>Lista</h3>
                            </div>
                        </div>

                        
                        {this.state.saved && (
                            <div className="botao-sem-linha2">
                            <button
                                className="salvar"
                                onClick={() => this.controllerModalCateg(this.state.modalCategoria)}>Criar nova categoria</button>
                            </div>
                        )}

                        <DragDropContext onDragEnd={this.handleOnDragEndCateg}>
                            <Droppable droppableId="categories" style={{cursor: "default"}}>
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {!!this.state.categorias.length && (
                                            this.state.categorias
                                            .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                            .map((categ, index) => (
                                                <div key={categ.id}>
                                                    <RenderCateg
                                                        key={categ.id}
                                                        index={index}
                                                        categ={categ}
                                                        categorias={this.state.categorias}
                                                        windowWidth={this.state.windowWidth}
                                                        isSuperUser={this.state.superUser}
                                                        permission={this.state.permission}
                                                        handleAtivoCateg={(id, ativo) => this.handleAtivoCateg(id, ativo)}
                                                        controllerModalApagar={(modalApagar, boolean, nome, id) => this.controllerModalApagar(modalApagar, boolean, nome, id)}
                                                        modalApagar={this.state.modalApagar}
                                                        isList={this.state.list}
                                                        handleOnDragEndProd={(res, id) => this.handleOnDragEndProd(res, id)}
                                                        controllerModalProduto={(modalProduto, boolean, content, nome, id) => this.controllerModalProduto(modalProduto, boolean, content, nome, id)}
                                                        modalProduto={this.state.modalProduto}
                                                        handleAtivo={(categ_id, id, ativo) => this.handleAtivo(categ_id, id, ativo)}
                                                        customError={(text) => this.customError(text)}
                                                    />
                                                </div>
                                            ))
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                        </>
                    ) : (
                        <h5>Você não cadastrou nenhuma categoria.</h5>
                    )
                }
            </div>

            {/* <hr className='linha1'/> */}

                {this.state.superUser ? (
                    this.state.permission === 2 ? (
                        this.state.saved && (
                            <div className="botao">
                            <button
                                className="salvar"
                                onClick={() => this.controllerModalCateg(this.state.modalCategoria)}>Criar nova categoria</button>
                            </div>
                        )
                    ) 
                    : null
                    
                ) : (
                    this.state.saved && (
                        <div className="botao-sem-linha">
                        <button
                            className="salvar"
                            onClick={() => this.controllerModalCateg(this.state.modalCategoria)}>Criar nova categoria</button>
                        </div>
                    )
                )}
            </div>

        </>
        : null}
        </Container>
    ))
    }
}

const StyledMenu = withStyles({
    paper: {
        position: 'absolute',
        width: 205,
        borderRadius: 8,
        top: 76,
        margin: 0,
        padding: 0
    }
  })(props => (
    <Menu
        TransitionComponent={Fade}  
        elevation={24}
        getContentAnchorEl={null}
        anchorOrigin={{
        vertical: "bottom", horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top", horizontal: "right"
      }}
      {...props}
    />
  ));
  const StyledMenuItem = withStyles(theme => ({
    root: {
        fontFamily: "Montserrat",
        fontSize: 16,
        color: "#7a6d6d",
        paddingLeft: 16,
        paddingTop: 16,
        paddingBottom: 16,
        margin: 0,
        "&:hover": {
            fontWeight: 500,
            color: "#3f2829",
            backgroundColor: "#faf8f8"
        }
    }
  }))(MenuItem);

const customStyles = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '823px',
        height: '100%',
        maxHeight: '754px'
      }
  };

  const customStylesMobile = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: `100vh`,
      }
  };
  const filtroStylesMob = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
      }
  };
  const customStylesCateg = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
        maxHeight: '536px'
      }
  };

  const apagarStyle = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '714px',
        height: '100%',
        maxHeight: '432px'
      }
  };